import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const BetaGammaRelation = () => (
  <QPhototModuleSubtopic
    title="Relation between Beta and Gamma Functions"
    videos={[
      "https://www.youtube.com/embed/z-A7VaVloo4"
    ]}
    takeaways={[
      { text: "The relation between the Beta and Gamma functions is: 𝛽(m, n) = Γ(m)Γ(n)/Γ(m+n)" }
    ]}
    questions={[
        {
            image:"/cal_57.jpeg"
        },
        {
            image:"/cal_58.jpeg"
        },
        {
            image:"/cal_59.jpeg"
        },
        {
            image:"/cal_60.jpeg"
        },
        {
            image:"/cal_61.jpeg"
        },
       
    ]}
    exampleVideos={[]}
  />
);

export default BetaGammaRelation;
